import { styled } from '$utils/theme'
import { rem } from 'polished'
import { Text } from '$views/components/Text'
import { Block } from '$views/components'
import { Icon } from '$views/components/Icon'
import { Link } from '$views/components/Link'

export const GridFooter = styled.div.attrs({})`
  width: 100%;
  background-color: ${p => p.theme.colors.darkGrey};
  background-size: cover;
  margin: auto
    ${p => p.theme.media.desktop`
    padding: ${rem(63)} ${rem(p.theme.sizes.mini)} ${rem(32)};
    max-width: ${rem(p.theme.grid.contentMaxWidth.wide)};
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    justify-items: start;
    align-items: start;
    grid-column-gap: ${rem(70)};
    grid-row-gap: ${rem(p.theme.sizes.medium)};
  `};
  ${p => p.theme.media.onlyMobile`
    padding: ${rem(50)} ${rem(p.theme.sizes.mini)} ${rem(32)};
    display: grid;
    grid-template-rows: auto;
    grid-row-gap: ${rem(70)};
  `};
`

export const StyledText = styled(Text)`
  grid-column: 1/3;
  grid-row: 3;
  ${p => p.theme.media.onlyMobile`
    grid-column: 1;
    grid-row: 6;
    margin-top: ${rem(p.theme.sizes.mini)};
  `};
`

export const BlockAlignEnd = styled(Block)`
  align-self: end;
`

export const IconApp = styled(Icon)`
  max-width: ${rem(166)};
`

export const StyledFooterLink = styled(Link)`
  &:hover {
    color: ${p => p.theme.colors.white} !important;
  }
`



// WEBPACK FOOTER //
// ./src/views/components/Footer/Footer.styles.ts